export default __webpack_public_path__ + "static/media/liz_knight.a8df31e7.png";